import React from "react";

import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function Footer() {
  gsap.registerPlugin(ScrollTrigger);

  useGSAP(() => {
    const top = document.querySelector(".top");
    gsap.set(top, {
      display:"none",
    });

    gsap.to(top, {
      scrollTrigger: {
        start: "1200px 80%",
        end: "1200px 20%",
        scrub: true,
      },
      display: "block",
    });
  });
  return (
    <section className="container">
      <div className="footer">
        <div className="icons">
          <div className="instagram">
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 0H7C3.134 0 0 3.134 0 7V18C0 21.866 3.134 25 7 25H18C21.866 25 25 21.866 25 18V7C25 3.134 21.866 0 18 0ZM12.5 18.5C9.186 18.5 6.5 15.814 6.5 12.5C6.5 9.186 9.186 6.5 12.5 6.5C15.814 6.5 18.5 9.186 18.5 12.5C18.5 15.814 15.814 18.5 12.5 18.5ZM19 7.5C18.172 7.5 17.5 6.828 17.5 6C17.5 5.172 18.172 4.5 19 4.5C19.828 4.5 20.5 5.172 20.5 6C20.5 6.828 19.828 7.5 19 7.5Z"
                fill="white"
              />
            </svg>
          </div>
          <div className="facebook">
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25.9998 12.9988C25.9918 19.5728 21.0828 25.1098 14.5558 25.9058C14.4138 25.9218 14.2718 25.8768 14.1658 25.7808C14.0588 25.6848 13.9988 25.5488 13.9998 25.4058V15.9988H16.9998C17.2768 15.9988 17.5418 15.8848 17.7318 15.6828C17.9208 15.4798 18.0178 15.2088 17.9998 14.9318C17.9538 14.3988 17.5038 13.9908 16.9688 13.9988H13.9998V10.9988C13.9998 9.89378 14.8948 8.99878 15.9998 8.99878H17.9998C18.2768 8.99878 18.5418 8.88478 18.7318 8.68278C18.9208 8.47978 19.0178 8.20878 18.9998 7.93178C18.9538 7.39778 18.5028 6.98978 17.9658 6.99878H15.9998C13.7908 6.99878 11.9998 8.78878 11.9998 10.9988V13.9988H8.99982C8.72282 13.9978 8.45782 14.1118 8.26782 14.3138C8.07882 14.5168 7.98182 14.7878 7.99982 15.0648C8.04582 15.5988 8.49682 16.0068 9.03382 15.9988H11.9998V25.4088C12.0008 25.5508 11.9408 25.6878 11.8348 25.7828C11.7288 25.8788 11.5868 25.9238 11.4448 25.9088C4.73082 25.0908 -0.238181 19.2688 0.00881901 12.5098C0.258819 5.75978 5.72582 0.271781 12.4808 0.00978081C16.0148 -0.127219 19.4518 1.17978 22.0018 3.62978C24.5518 6.07978 25.9958 9.46178 25.9998 12.9988Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
        <div className="details">
          <div className="item">
            <span>PHONE :</span>
            <p>+373 60 305767</p>
            <p>+373 60 531017</p>
          </div>
          <div className="item">
            <span>EMAIL :</span>
            <p>ModernWebHub@outlook.com</p>
          </div>
        </div>
      </div>
      <p className="copyright">
        <sup>©</sup>Copyright | All Rights Reserved | 2023
      </p>
      <div
        className="top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <button className="button-top">
          <svg className="svgIcon" viewBox="0 0 384 512">
            <path d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"></path>
          </svg>
        </button>
      </div>
    </section>
  );
}
